import VerificationsHistoryPage from './VerificationsHistoryPage';

export default VerificationsHistoryPage;
